import React, { RefObject, useState } from 'react'
import { Form, InputGroup } from 'react-bootstrap'
import { MapRef } from 'react-map-gl'
import { API } from '../../api'

import searchSrc from '../../assets/img/icons/SearchIcon.svg'
import closeSrc from '../../assets/img/icons/Close.svg'

interface CustomSearchProps {
  mapRef: RefObject<MapRef>
}

interface Suggestion {
  name: string
  properties: {
    mapLocation: {
      address: {
        coordinates: {
          lat: number
          lng: number
        }
      }
    }
  }
}

const CustomSearchBox = ({ mapRef }: CustomSearchProps) => {
  const [suggestions, setSuggestions] = useState([])
  const [selectedLocation, setSelectedLocation] = useState<Suggestion>()
  const [searchQuery, setSearchQuery] = useState<string>()
  const [isFocused, setIsFocused] = useState(false)
  const showClose = searchQuery && searchQuery?.length > 0
  // @ts-ignore
  const handleChange = async e => {
    setIsFocused(true)

    if (e.target.value === '' || e.target.value.length < 1) {
      setIsFocused(false)
      setSearchQuery(undefined)
      setSelectedLocation(undefined)
      setSuggestions([])
    }

    setSearchQuery(e.target.value)

    try {
      const searchResults = await API.get('/search', {
        params: { q: e?.target?.value }
      })
      setSuggestions(searchResults?.data?.message?.items)
    } catch (e) {
      setSuggestions([])
    }
  }

  // @ts-ignore
  const handleKeyDown = e => {
    if (e?.key === 'Enter' && selectedLocation) {
      const coords = selectedLocation.properties.mapLocation.address.coordinates

      mapRef.current?.flyTo({
        center: coords,
        zoom: 13
      })
    }
  }

  return (
    <div className="searchbar">
      <InputGroup className="mb-1">
        <InputGroup.Text
          style={showClose ? { cursor: 'pointer' } : undefined}
          id="search-trigger"
          className="rounded-lg"
          onClick={() => {
            if (showClose) {
              setSearchQuery('')
              setSelectedLocation(undefined)
              setIsFocused(false)
            }
          }}
        >
          <img src={showClose ? closeSrc : searchSrc} width={15} height={15} />
        </InputGroup.Text>
        <Form.Control
          // @ts-ignore
          onFocus={() => {
            setIsFocused(true)
            setSuggestions([])
          }}
          onKeyDown={handleKeyDown}
          value={searchQuery}
          // @ts-ignore
          onChange={handleChange}
          className="rounded-lg"
          placeholder="Search is case sensitive."
          aria-label="Search"
        />
      </InputGroup>
      {suggestions.length > 0 && isFocused && (
        <ul id="suggestions-container">
          {suggestions.map((i: Suggestion, index) => (
            <li
              key={i.name ?? index}
              onClick={() => {
                setIsFocused(false)

                if (!i) return
                setSelectedLocation(i)
                setSearchQuery(i?.name)

                const coords = i.properties.mapLocation.address.coordinates
                mapRef.current?.flyTo({
                  center: coords,
                  zoom: 13
                })
              }}
            >
              {i.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default CustomSearchBox
